<!--
 * @Autor: yzr
 * @Date: 2021-07-20 10:37:32
 * @LastEditors: yzr
 * @LastEditTime: 2021-09-09 10:59:52
 * @Description: 分利协议主体列表
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';

export default {
  name: 'modules',
  extends: TablePage,
  data() {
    return {
      // requestType: 'GET',
      // requestUrl: '/cps/v1/web/scanCodeRecordReport/findByConsumerConditions',
      requestType: 'POST',
      requestUrl: '/cps-mobile/consumer/scan/activity/consumerScanActivityReport/findConsumerScanReport', // 最新
      params: {
      },
      formConfig: {},
      modalConfig: {
      },
    };
  },
  async created() {
    await this.getConfigList('cps-web-customer_record_flow-list');
  },
  mounted() {
  },
  methods: {
  },
};
</script>
